<template>
  <div>

    <div v-if="error" class="error" v-html="error"></div>


    <div class="loading" v-if="loading">
      <div class="wrapper">
        <span class="spinner"></span>
        <p class="sr-only">Loading...</p>
      </div>
    </div>

    <div class="sponsors-list" v-else>
      <header class="sponsors-list--header">
        <div class="wrapper">
          <h1>Sponsors</h1>
        </div>
      </header>

      <div class="wrapper">
        <div class="sponsors-list--grid">
          <SponsorThumbnail v-for="sponsor in filteredSponsors" :key="sponsor.id" :sponsor="sponsor">
            <template #sponsorinfo>
              <div class="inner sponsor-info">
                <img v-if="sponsor.acf_json && sponsor.acf_json.sponsor" :src="sponsor.acf_json.sponsor.sizes.thumbnail" />
                <div class="image-placeholder" v-else>
                  <span><FontAwesomeIcon :icon="icon.user" class="user-icon" /></span>
                </div>
                <div class="contact-info">

                  <a class="secondary" :href="`tel:+1${sponsor.acf.telephone.replace('ext', ',').replaceAll(/[^0-9,]/g, '')}`">{{ sponsor.acf.telephone }}</a>

                  <a class="secondary email-address" :href="`mailto:${sponsor.meta.email}`">{{ sponsor.meta.email }}</a>

                  <router-link :to="`/sponsors/${sponsor.slug}`" class="profile">
                    View Profile
                  </router-link>
                </div>


              </div>
            </template>
          </SponsorThumbnail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SponsorThumbnail from '@/components/SponsorThumbnail'
import { faUser } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'SponsorsList',
  components: {
    SponsorThumbnail
  },
  mounted() {
    this.$store.dispatch('getSponsors').then(() => {
      this.loading = false
      this.sponsors = this.$store.getters.getSponsors
    })
  },
  computed: {
    error() {
      return this.$store.getters.getError
    },
    filteredSponsors() {
      return this.sponsors.filter(sponsor => {
        return sponsor.name.toLowerCase().includes(this.search.toLowerCase())
      }).sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  data() {
    return {
      icon: {
        user: faUser
      },
      loading: true,
      search: '',
      sponsors: []
    }
  },
  methods: {
  },
  metaInfo() {
    return {
      title: 'Our Sponsors'
    }
  }
}
</script>
